import React from 'react';
import { injectIntl } from 'react-intl';
import { Card, CardContent, Grid, Typography } from '@mui/material';

const irrValueStyle = { color: '#665EFF', fontWeight: 600 };

const IRRCard = ({ intl, years, yearlyIRR }) => {
  // Skip index 0 (year 0 baseline, IRR = 0)
  const displayYears = (years || []).slice(1);
  const displayIRR = (yearlyIRR || []).slice(1);

  return (
    <Card className="pfa-card pf-card-container">
      <CardContent>
        <Typography variant="subtitle2" style={{ marginBottom: 8, fontWeight: 600 }}>
          {intl.formatMessage({ id: 'pfa-irr-card-title' })}
        </Typography>
        <Grid container spacing={1}>
          {displayYears.map((year, i) => (
            <Grid size={12} key={year}>
              <Grid container sx={{ alignItems: "center",  justifyContent: "space-between" }} >
                <Grid>
                  <Typography variant="body2" color="textSecondary">
                    {intl.formatMessage({ id: 'pfa-year' }, { year })}
                  </Typography>
                </Grid>
                <Grid>
                  <Typography variant="body2" style={irrValueStyle}>
                    {!isNaN(displayIRR[i]) ? `${displayIRR[i]?.toFixed(2) ?? '0'}%` : '-'}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default injectIntl(IRRCard);
